<template>
  <transient-status :isLoading="isLoading" :error="error">
    <slot v-if="page" v-bind:page="page" v-bind:error="error"></slot>
    <countdown v-if="countdown" interval="60" @tickerReachedZero="getData()" />
  </transient-status>
</template>

<script>
import TransientStatus from '@/components/TransientStatus.vue'
import Countdown from '@/components/Countdown.vue'

export default {
  props: ['pageName', 'parameters', 'countdown', 'updateflag'],
  components: { TransientStatus, Countdown },
  data() {
    return {
      page: null,
      isLoading: true,
      error: null,
    };
  },
  watch: {
    // when someone updates this flag, we need to fetch the data again
    'updateflag' (newValue) {
      if ((newValue || '') === '') {
        return // ignore empty/null values as a `magic value` for special cases
      }
      console.log('update flag changed, so updating data', newValue)
      this.getData()
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.isLoading = true;
      this.error = null;
      const { access_token } = this.$store.state.oidcStore;
      this.$reportingApi.renderPage('landscape', access_token, {
        pageName: this.pageName,
        parameters: typeof(this.parameters) === 'undefined' ? null : this.parameters,
      })
      .then((d) => {
        this.page = d;
      })
      .catch((e) => {
        console.error('Error rendering page', e.message);
        this.error = e.message;
      })
      .finally(() => {
        this.isLoading = false;
      });
    }
  }
}
</script>
